module.exports = " <span class=checkbox> <input type=checkbox v-bind:value=value> <i class=\"paco icon icon-right\"></i> <slot></slot> </span> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Check.vue
// module id = 122
// module chunks = 1